<template>
  <div class="container">
    <div class="confirmationContainer">
      <div
        v-if="emailAddress !== ''"
        class="NotifiUserInfoPanel__emailContainer"
      >
        <label class="NotifiUserInfoPanel__emailLabel">{{
          emailAddress
        }}</label>
        <span
          v-if="showEmailConfirmationLinkSent === true"
          class="NotifiUserInfoPanel__confirmationLinkSentLabel"
        >
          Email sent!</span
        >
        <span
          v-else-if="
            showEmailConfirmationLinkSent === false &&
            emailIdThatNeedsConfirmation !== ''
          "
          @click="handleResendVerificationLink"
        >
          <label class="NotifiUserInfoPanel__emailConfirmationLabel">
            Send Link
          </label>
        </span>
      </div>
    </div>
    <div
      v-if="phoneNumber !== ''"
      class="NotifiUserInfoPanel__phoneNumberContainer"
    >
      <label class="NotifiUserInfoPanel__phoneNumberLabel">{{
        phoneNumber
      }}</label>
    </div>
    <div
      v-if="telegramId !== ''"
      class="NotifiUserInfoPanel__telegramContainer"
    >
      <label class="NotifiUserInfoPanel__telegramLabel">{{ telegramId }}</label>
      <a
        v-if="telegramVerificationUrl !== ''"
        target="__blank"
        :href="telegramVerificationUrl"
      >
        <label class="NotifiUserInfoPanel__telegramConfirmationLabel">
          Verify ID
        </label>
      </a>
    </div>
    <p-button
      class="p-button-secondary justify-content-center notifi-edit-button"
      @click="setCardState('edit')"
    >
      Edit
    </p-button>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useNotifiStore } from '../../../stores';

const notifiStore = useNotifiStore();
const {
  emailAddress,
  phoneNumber,
  telegramId,
  emailIdThatNeedsConfirmation,
  telegramVerificationUrl,
} = storeToRefs(notifiStore);

const { setCardState, resendEmailVerificationLink } = notifiStore;
const showEmailConfirmationLinkSent = ref<boolean>(false);

const handleResendVerificationLink = () => {
  showEmailConfirmationLinkSent.value = true;

  resendEmailVerificationLink();
  setTimeout(() => {
    showEmailConfirmationLinkSent.value = false;
  }, 5000);
};
</script>
<style scoped lang="css">
.container {
  display: flex;
  flex-direction: column;
  padding: 0px 24px 0px 24px;
}
</style>

<style lang="scss" scoped>
.NotifiUserInfoPanel__emailContainer,
.NotifiUserInfoPanel__phoneNumberContainer,
.NotifiUserInfoPanel__telegramContainer {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}

.NotifiUserInfoPanel__emailConfirmationLabel,
.NotifiUserInfoPanel__telegramConfirmationLabel {
  cursor: pointer;
  font-size: 16px;
  color: #8959ef;
  font-weight: 500;
}

.NotifiUserInfoPanel__emailLabel {
  max-width: 250px;
  word-wrap: break-word;
}

.notifi-edit-button {
  border-color: #6e42ca;
  color: #6e42ca;
  width: 164px;
  border-radius: 150px;
  margin-top: 22px;
  margin-bottom: 27px;
}

.NotifiUserInfoPanel__confirmationLinkSentLabel {
  font-size: 12px;
  margin-top: 5px;
}
</style>
